export { LoadingPresenter as Loading } from './Loading.presenter';
